(() => {
  const selector = '.tarteaucitronAlertBigBottom';
  let el = null;
  let shown = false;

  // 1) Element finden (kann später auftauchen)
  const findEl = () => document.querySelector(selector);

  // 2) Beim ersten Scroll einblenden, sobald Element existiert
  const onScroll = () => {
    if (shown) return;

    el = el || findEl();
    if (!el) return; // noch nicht da -> beim nächsten Scroll wieder versuchen

    el.classList.add('visible');
    shown = true;
    window.removeEventListener('scroll', onScroll);
    observer?.disconnect?.();
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  // 3) Optional: Falls es nach dem Laden ohne Scroll ins DOM kommt,
  //    beobachten wir DOM-Änderungen und merken uns das Element.
  const observer = new MutationObserver(() => {
    if (el) return;
    el = findEl();
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
})();